import React from "react";
import * as Sentry from "@sentry/react";

export class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, errorInfo) {
    console.error("Error capturado en ErrorBoundary:", error, errorInfo);
    Sentry.captureException(error, {
      extra: { componentStack: errorInfo?.componentStack },
      tags: { boundary: this.props.name ?? "unknown" },
    });
  }

  handleGoHome = () => {
    window.location.assign(localStorage.getItem("companyHome") || "/");
  };

  handleReload = () => {
    window.location.reload();
  };

  render() {
    if (this.state.hasError) {
      const { title = "Algo salió mal", description } = this.props;
      return (
        <div style={{ padding: "20px", color: "red" }}>
          <h2>{title}</h2>
          {description && <p>{description}</p>}
          {import.meta.env.DEV && (
            <details style={{ whiteSpace: "pre-wrap" }}>
              {this.state.error && this.state.error.toString()}
            </details>
          )}
          <button onClick={this.handleGoHome}>Volver al inicio</button>{" "}
          <button onClick={this.handleReload}>Recargar</button>
        </div>
      );
    }

    return this.props.children;
  }
}
